import { Body, Controller, Injectable, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from 'packages/backend-utils/src/lib/exception-handling/application-exception-handler';
import { ApiTags } from '@nestjs/swagger';
import { CommonResponseModel } from '@needle-management/shared-models'
import { StockOutService } from './stock-out-service';

@ApiTags('stock-out')
@Controller('stock-out')
@Injectable()
export class StockOutController {
    constructor(
        private readonly stockOutService: StockOutService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
        
      ) {}


      @Post('/getStockOutData')
      async getStockOutData(): Promise<CommonResponseModel> {
          try {
            return await this.stockOutService.getStockOutData();
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }
    
}
